import { render, staticRenderFns } from "./ThongTinChung.vue?vue&type=template&id=f737ec08&"
import script from "./ThongTinChung.vue?vue&type=script&lang=js&"
export * from "./ThongTinChung.vue?vue&type=script&lang=js&"
import style0 from "./ThongTinChung.vue?vue&type=style&index=0&id=f737ec08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports